module.exports = __webpack_public_path__ + "img/gygx_03.7d7730c7.jpg";